module.exports = __webpack_public_path__ + "assets/img/group-member-icon.f30bf376.png";